import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { fetchLiveEvents } from "@/lib/intel/feeds.functions";

const FALLBACK = [
  "CARIO INTEL · live OSINT bus warming up",
  "Public collectors: DNS · RDAP · CT · NVD · CISA KEV · HN · Wikipedia · GitHub",
];

export function Ticker() {
  const fetcher = useServerFn(fetchLiveEvents);
  const { data } = useQuery({
    queryKey: ["ticker-events"],
    queryFn: () => fetcher(),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
  const items = (data && data.length ? data.slice(0, 14).map((e) => `${e.source} · ${e.title}`) : FALLBACK);
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-panel-border bg-panel/40 py-1.5">
      <div className="ticker flex gap-10 whitespace-nowrap font-mono text-[11px] text-muted-foreground">
        {row.map((t, i) => (
          <span key={i} className="flex shrink-0 items-center gap-2 truncate max-w-[70vw] sm:max-w-[480px]">
            <span className="h-1 w-1 shrink-0 rounded-full bg-cyan pulse-dot" />
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
